import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import {
  DEFAULT_DATA_STORAGE_BYTES,
  DEFAULT_FILE_STORAGE_BYTES,
  parseStorageGbInput,
  storageBytesToGbInput,
} from './AdminPlanConfigConstants';

/**
 * Plan / company_subscription storage limit fields.
 * Values are stored as bytes in config.storage; admin enters GB.
 */
const StorageLimitsFields = ({
  storage,
  onChange,
  disabled,
  subtitle,
}) => {
  const dataGb = storageBytesToGbInput(storage?.dataLimitBytes ?? DEFAULT_DATA_STORAGE_BYTES);
  const fileGb = storageBytesToGbInput(storage?.fileLimitBytes ?? DEFAULT_FILE_STORAGE_BYTES);

  const handleDataLimitChange = (e) => {
    const bytes = parseStorageGbInput(e.target.value);
    if (bytes === null) return;
    onChange((prev) => ({
      ...prev,
      storage: { ...(prev.storage || {}), dataLimitBytes: bytes },
    }));
  };

  const handleFileLimitChange = (e) => {
    const bytes = parseStorageGbInput(e.target.value);
    if (bytes === null) return;
    onChange((prev) => ({
      ...prev,
      storage: { ...(prev.storage || {}), fileLimitBytes: bytes },
    }));
  };

  return (
    <Card className="p-3">
      <h5>Storage</h5>
      <Form.Text className="d-block mb-3 text-muted small">
        {subtitle ||
          'Tenant-wide storage limits for database records and file attachments. Stored in bytes; enter values in GB. −1 = unlimited.'}
      </Form.Text>
      <Row className="g-3">
        <Col md={6}>
          <Form.Group className="mb-0">
            <Form.Label>Data Storage Limit (GB)</Form.Label>
            <Form.Control
              type="number"
              min={-1}
              step={0.01}
              value={dataGb}
              onChange={handleDataLimitChange}
              disabled={disabled}
            />
            <Form.Text className="text-muted small">
              CRM record data (excluding file attachments). Default: 20 GB.
            </Form.Text>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-0">
            <Form.Label>File Storage Limit (GB)</Form.Label>
            <Form.Control
              type="number"
              min={-1}
              step={0.01}
              value={fileGb}
              onChange={handleFileLimitChange}
              disabled={disabled}
            />
            <Form.Text className="text-muted small">
              Attachments and uploaded files. Default: 100 GB.
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>
    </Card>
  );
};

export default StorageLimitsFields;
